import { defineComponent } from "vue";
import { refMethod, VueEmit, VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { ModuleMenuScreenData } from "../menuData";
import { FocusHandler } from "./focusHandler";
import NewWindowButton from "./newWindowButton";

export interface ScreenButtonClasses
{
    unselectedClass: string;
    selectedClass: string;
    labelClass: string;
    newWindowIconClass: string;
}

export default /*#__PURE__*/ defineComponent(
{
    name: "screenButton",
    props:
    {
        moduleMenuScreenData: VueProp<ModuleMenuScreenData>(),
        screenButtonClasses: VueProp<ScreenButtonClasses>(),
        focusHandler: VueProp<FocusHandler>()
    },
    emits:
    {
        selectScreen: VueEmit<(moduleMenuScreenData: ModuleMenuScreenData, newWindow: boolean) => void>()
    },
    computed:
    {
        isUtility(): boolean
        {
            if (this.moduleMenuScreenData.module === null || this.moduleMenuScreenData === null || this.moduleMenuScreenData.screen === null)
            {
                return false;
            }

            const workflowScreenRegex = /^Create\/.+\/.+\/.+$/i;
            return this.moduleMenuScreenData.module === "Workflow" && this.moduleMenuScreenData.object === "WorkflowInstance" && workflowScreenRegex.test(this.moduleMenuScreenData.screen);
        }
    },
    render()
    {
        return (
            <a
                ref={refMethod<HTMLElement>((el) => this.focusHandler.setScreenButton(this.moduleMenuScreenData, el))}
                class={this.moduleMenuScreenData.selected ? this.screenButtonClasses.selectedClass : this.screenButtonClasses.unselectedClass}
                aria-label={"Go to " + this.moduleMenuScreenData.displayText}
                href="javascript:void(0)"
                aria-haspopup={this.isUtility ? "dialog" : undefined}
                onClick={(e: MouseEvent) => this._onClick(this.moduleMenuScreenData, e)}
                onKeydown={(e: KeyboardEvent) => this._onKeyDown(this.moduleMenuScreenData, e)}
                role="menuitem"
            >
                <span class={this.screenButtonClasses.labelClass}>{this.moduleMenuScreenData.displayText}</span>
                {this.moduleMenuScreenData.renderNewWindowButton && <NewWindowButton moduleMenuScreenData={this.moduleMenuScreenData} iconClass={this.screenButtonClasses.newWindowIconClass} />}
            </a>
        );
    },
    methods:
    {
        _onClick(moduleMenuScreenData: ModuleMenuScreenData, e: MouseEvent): void
        {
            const target = e.target as HTMLElement;
            const newWindow = target.classList.contains(Classes.moduleScreensNewWindowButton);

            this.$emit("selectScreen", moduleMenuScreenData, newWindow);
        },
        _onKeyDown(moduleMenuScreenData: ModuleMenuScreenData, e: KeyboardEvent): void
        {
            e.preventDefault();
            this.focusHandler.moveFocusFromScreen(moduleMenuScreenData, e);
        }

    }
});
